import { render } from "./PublicSearchResult.vue?vue&type=template&id=bd4380ec&scoped=true&ts=true"
import script from "./PublicSearchResult.vue?vue&type=script&lang=ts"
export * from "./PublicSearchResult.vue?vue&type=script&lang=ts"

import "./PublicSearchResult.vue?vue&type=style&index=0&id=bd4380ec&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd4380ec"]])

export default __exports__